import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const Bar = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: "8px",
  paddingLeft: "32px",
  paddingRight: "32px",
  paddingTop: "8px",
  paddingBottom: "16px",
  alignItems: "center"
})

export const Separator = styled(Box)({
  width: "1px",
  height: '28px',
  borderRadius: "0px",
  background: "var(--brand-white-default)",
  marginLeft: "16px",
  marginRight: "16px",
})

export const Spacer = styled(Box)({
  flex: 1,
})

export const AssignedToLabel = styled(Typography)({
  color: "var(--brand-text-sec)",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  alignSelf: "center",
})

export const AssignedToName = styled(Typography)({
  color: "var(--brand-text-default)",
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  alignSelf: "center",
  marginTop: "0px",
  marginBottom: "0px",
})

export const AssignedToSlugs = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  color: "var(--brand-text-default)",
})
